import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    resource: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { resource } = this.props
    return {
      title: 't(Edit Resource)',
      method: 'PATCH',
      endpoint: `/api/admin/truevail/admin/resources/${resource.id}/edit`,
      action: `/api/admin/truevail/admin/resources/${resource.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)',
              name: 'title', 
              type: 'textfield',
              required: true 
            },
            { 
              label: 't(Description)',
              name: 'description',
              type: 'textarea'
            },
            { 
              label: 't(Document)',
              name: 'asset_id', 
              type: 'attachmentfield',
              required: true 
            },
            { 
              label: 't(Thumbnail)',
              name: 'thumbnail_id', 
              type: 'attachmentfield'
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(result) {
    this.context.modal.close()
  }

}

export default Edit
